<template>
    <div
        class="chat__contact px-2 pt-4 pb-2"
        :class="{
            'chat__inbox-contact': contact.inbox && !contact.pickableInboxChat,
            'bg-primary-gradient text-white shadow-lg': isActiveChatUser && contact.protocol,
            'bg-warning-gradient text-white shadow-lg': contact.isNotResponded && (!contact.inbox || contact.pickableInboxChat),
            'bg-warning-gradient text-white shadow-lg': unseenMsg > 0 && contact.customerLastChat && (contact.customerLastChat.type == 1 || contact.customerLastChat.is_bot_message) && !isActiveChatUser  
        }"
    >
        <div v-if="contact && contact.customer && contact.customer.is_blacklisted" style="width: 100%;">
            <vs-chip color="#888" style="width: 100%;">{{ contact.customer.is_blacklisted_campaign ? 'Bloqueado da Campanha' : (contact.customer.is_blacklisted ? 'Bloqueado da Campanha' : '') }}</vs-chip>
        </div>

        <div v-if="selectedTab !== 'inbox' && selectedTab !== 'my_chats'" style="width: 100%;">
            <vs-chip color="transparent" class="border-chip" v-if="contact.finished_at === null" style="width: 100%;">
                <span v-if="hasAttendance(contact)" style="color: #B50000; font-weight: bold;">
                    ABERTO SEM ATENDENTE
                </span>
                <span v-else style="color: #888">
                    ABERTO
                </span>
            </vs-chip>
            <vs-chip color="#888" v-else style="width: 100%;">
                <span>
                    FECHADO
                </span>
            </vs-chip>
        </div>

        <div class="clearfix"></div>

        <div
            class="flex items-center"
        >
            <vs-checkbox v-if="showSelectList" v-model="selected" @click.stop="selectContact(contact)"/>
            <div class="contact__avatar mr-1">
                <div v-if="instanceColor">
                  <div :title="instanceColor.name" :style="{ backgroundColor: instanceColor.color }" class="instance-color"></div>
                </div>

                <vs-avatar
                    v-if="contact.customer.image"
                    class="border-2 border-solid border-white"
                    :src="contact.customer.image"
                    size="42px"
                />
                <vs-avatar v-else class="border-2 border-solid border-white" size="42px" />
            </div>
            <div class="contact__container w-full flex items-center justify-between overflow-hidden">
                <div class="contact__info flex flex-col truncate w-5/6">
                    <div v-if="transferring">
                        <vs-chip
                          style="background-color: rgba(73, 58, 193, 0.8)"
                          color="warning"
                        >Transferindo</vs-chip>
                    </div>
                    <div v-else-if="contact.is_finishing">
                        <vs-chip color="warning">Encerrando</vs-chip>
                        <span
                            v-if="lastMessage && !!contact.user"
                            :class="`${isActiveChatUser ? 'text-white' : 'text-grey'} truncate`"
                            :style="{float: 'right'}"
                        >
                            {{ sentAtFormatted }}
                        </span>
                    </div>
                    <div v-else-if="
                        research || (contact.is_research)
                    ">
                        <vs-chip class="vs-chip-research" >Pesquisa</vs-chip>
                        <span
                            v-if="lastMessage"
                            :class="`${isActiveChatUser ? 'text-white' : 'text-grey'} truncate`"
                            :style="{float: 'right'}"
                        >
                            {{ sentAtFormatted }}
                        </span>
                    </div>
                    <div v-else>
                        <div class="flex mb-1 items-center">
                            <TagComponent 
                                :groups="contact.customer.group_of_customer"
                                v-if="contact.customer.group_of_customer !== undefined && 
                                contact.customer.group_of_customer.length !== 0"
                            />

                            <h5
                                class="font-semibold ml-1"
                                id="adjust-customer-name"
                                :class="{'text-white': isActiveChatUser}"
                                :style="{float: 'left'}"
                            >
                                {{ contact.customer.name }}
                            </h5>

                            <div v-if="Boolean(contact.bot_is_active)" class="ml-2">
                              <vs-chip class="vs-chip-maria" >Maria</vs-chip>
                            </div>

                            <!--
                            // PARA DEBUGAR, FAVOR MANTER ESSA LÓGICA!!!!
                            <div v-if="Boolean(contact.priority)" class="ml-2">
                              <vs-chip :color="(contact.priority == 1 ? 'success' : (contact.priority == 2 ? 'warning' : 'danger'))">
                                {{ contact.priority == 1 ? 'Baixa' : (contact.priority == 2 ? 'Média' : 'Alta') }}
                              </vs-chip>
                            </div>
                            -->

                            <feather-icon
                              v-if="contact.customer.is_favorite"
                              icon="StarIcon"
                              svgClasses="h-4 w-4"
                              class="cursor-pointer ml-2"
                              style="color: #faff00;"
                            ></feather-icon>
                        </div>

                        <span v-if="showPhoneNumber">{{ maskedPhone }}</span>
                        <span
                            v-if="lastMessage && !!contact.user"
                            :class="`${isActiveChatUser ? 'text-white' : 'text-grey'} truncate`"
                            :style="{float: 'right'}"
                        >
                            {{ sentAtFormatted }}
                        </span>
                    </div>
                    <div>
                        <span v-if="lastMessage" class="truncate" :title="lastMessageFormatted">
                            <span
                                v-if="lastMessage.tag_type === 'image' || lastMessage.tag_type === 'sticker'"
                                style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="ImageIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                {{ lastMessage.tag_type === 'image' ? 'Imagem' : 'Figurinha' }}
                            </span>

                            <span
                                v-else-if="lastMessage.tag_type === 'audio' || lastMessage.tag_type === 'ptt'"
                                style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="MicIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                Audio
                            </span>

                            <span
                                v-else-if="lastMessage.tag_type === 'video'"
                                style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="VideoIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                Video
                            </span>

                            <span
                                v-else-if="lastMessage.tag_type === 'location'"
                                style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="MapPinIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                Localização
                            </span>

                            <span
                                v-else-if="lastMessage.tag_type === 'contact'"
                                style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="UserIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                Contato
                            </span>

                            <span
                                    v-else-if="lastMessage.tag_type === 'payment'"
                                    style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="DollarSignIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                Pagamento
                            </span>

                            <span
                                    v-else-if="lastMessage.tag_type === 'order'"
                                    style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="ShoppingCartIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                Pedido
                            </span>

                            <span
                                v-else-if="
                                    lastMessage.tag_type === 'document'
                                    || lastMessage.tag_type === 'doc'
                                    || lastMessage.tag_type === 'pdf'
                                "
                                style="display: flex; flex-direction: row; align-items: center;"
                            >
                                <feather-icon icon="FileTextIcon" class="mr-1" svgClasses="h-5 w-5"/>
                                {{ lastMessage.document_name || 'Documento' }}
                            </span>

                            <span v-else>
                                <div v-html="lastMessageFormatted"/>
                            </span>
                        </span>

                        <span v-else-if="!lastMessage && !showPhoneNumber" class="truncate">&nbsp;</span>
                    </div>
                </div>

                <div
                    class="chat__contact__meta flex self-start flex-col items-end"
                    :class="!!contact.user ? 'w-1/6' : 'w-5/6'"
                    style="margin-right: 10px;"
                    v-if="!!contact.user"
                >
                    <span class="whitespace-no-wrap">
                        {{ lastMessaged | date }}
                    </span>
                    <vs-chip class="number" color="primary" v-if="unseenMsg && !isActiveChatUser">
                        {{ unseenMsg }}
                    </vs-chip>
                    <div
                        v-else
                        style="height: 23px;"
                    ></div>

                    <div
                        style="margin-top: 10px"
                        @click.stop="stopParentClick"
                        v-if="finishedTickets"
                    >
                      <feather-icon
                          icon="InfoIcon"
                          class="cursor-pointer"
                          @click.prevent='openContactDropdown(contact)'
                      />
                    </div>
                </div>

                <div
                    v-else-if="selectedTab === 'inbox'"
                    class="inbox-contact-picker"
                    @click.stop="stopParentClick"
                >
                  <inbox-timer
                      :timestamp="createdAt"
                      :currentTimestamp="currentTimestamp"
                      v-if="contact.id !== undefined"
                  />
                  <vs-button
                      type="border"
                      v-if="(contact.pickableInboxChat || contact.customer.is_favorite) && !transferring"
                      class="inbox-dropdown__picking-button"
                      @click.prevent='openPickingPopup(contact)'
                  >
                    <span class="vs-button-text vs-button--text attendance-span">
                      <span>PEGAR</span>
                    </span>
                  </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatDate, getCurrentTenant, maskPhoneNumber, stylizeMessage, getTimeZone, instanceObject } from '@/utils';
import InboxTimer from './InboxTimer.vue';
import TagComponent from '@/components/group-of-customer/Tag.vue';

export default {
  components: {
    InboxTimer,
    TagComponent
  },
  data() {
    return {
      transferring: false,
      research: null,
      selected: false,
    }
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    lastMessage: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    isActiveChatUser: {
      type: Boolean
    },
    finishedTickets: {
      type: Boolean
    },
    lastMessaged: {
      type: String,
      default : ""
    },
    unseenMsg: {
      type: Number,
      default : 0
    },
    showPhoneNumber: {
      type: Boolean,
      default: true
    },
    showSelectList: {
      type: Boolean,
      default: false
    },
    selectAllContacts: {
      type: Boolean,
      default: false
    },
    ticketsTransferring: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null
    },
  },
  watch: {
    transferring(val) {
      if (val) {
        setTimeout(() => {
          if (this.transferring){
            this.$events.emit('CheckSocket', { 'refresh': true })
          }
        }, 90000);

        setTimeout(() => {
          const remove = this.contact
            && !this.transferring
            && this.ticketsTransferring
            && this.ticketsTransferring.lenght > 0
            && this.ticketsTransferring.indexOf(this.contact.id) > -1;

          if (remove){
            this.$emit('onTransferredChat', this.contact);
          }
        }, 15000);
      }
    },
    selectAllContacts(selectAll) {
      this.selected = selectAll;
      this.$emit('contactSelected', this.contact.id, selectAll);
    },
    showSelectList(show) {
      if (!show) {
        this.selected = show;
        this.$emit('contactSelected', this.contact.id, show);
      }
    }
  },
  mounted() {
    this.$events.on('NotificationsLabels', (event) => {
      if (event.label !== 'research') {
        return
      }

      if (this.contact.id === event.item.id) {
        this.research = true
      }
    });

    this.$events.on('chatTicketResearchCanceled', async ({chatTicket, tenantName}) => {
      if ( tenantName === getCurrentTenant() && this.contact && chatTicket && this.contact.id === chatTicket.id ) {
        this.research = false
      }
    })

    this.$events.on('DeleteChatTicketTransferCloseModal', async({ticketTransfer}) => {
      if (ticketTransfer.chat_ticket_id === this.contact.id) {
        this.transferring = false
      }
    })

    this.$events.on('ChatTicketTransferringLabelUpdate', async({chatTicket, isTransferring}) => {
      if (chatTicket.id === this.contact.id) {
        this.transferring = isTransferring
      }
    })

    this.$events.on('ChatTicketTransferring', async ({
        chatTicket,
        tenantName,
        inbox = false,
        inboxDepartmentId = null
    }) => {
      const { AppActiveUser: activeUser, chatContact } = this.$store.state;

      const shouldTransfer = tenantName === getCurrentTenant()
          && this.contact
          && chatTicket
          && this.contact.id === chatTicket.id
          && !this.transferring;

      const shouldTransferInboxChatFromDepartment = inbox
          && inboxDepartmentId
          && activeUser.userDepartment
          && inboxDepartmentId !== activeUser.userDepartment.id
          && activeUser.role.name !== 'administrador'
          && chatContact.chatTab === 'inbox'
          && shouldTransfer;

      if (
          (shouldTransferInboxChatFromDepartment || (shouldTransfer && !inbox)) ||
          (shouldTransfer && ( this.contact.user !== null && inbox === true ))
      ) {
        this.transferring = true
        this.$emit('onTransferringChat', chatTicket);
      }
    })

    this.$events.on('ChatTicketTransferred', async ({
      chatTicket,
      tenantName,
      inbox = false,
      inboxDepartmentId = null
    }) => {
      new Promise(() => {
        const { AppActiveUser: activeUser, chatContact } = this.$store.state;

        const shouldTransfer = tenantName === getCurrentTenant()
            && this.contact
            && chatTicket
            && this.contact.id === chatTicket.id;

        const shouldTransferInboxChatFromDepartment = inbox
            && inboxDepartmentId
            && activeUser.userDepartment
            && inboxDepartmentId !== activeUser.userDepartment.id
            && activeUser.role.name !== 'administrador'
            && chatContact.chatTab === 'inbox'
            && shouldTransfer;

        if (
          (shouldTransferInboxChatFromDepartment || (shouldTransfer && !inbox)) ||
          (shouldTransfer && ( this.contact.user !== null && inbox === true ))
        ) {
          setTimeout(() =>{
            this.transferring = false
            this.$emit('onTransferredChat', chatTicket);
          }, 550);
        }
      })
    })
  },
  computed: {
    maskedPhone() {
      return maskPhoneNumber(this.contact.customer.phone_number);
    },
    createdAt() {
      return getTimeZone(this.contact.createdAt, 'timeCount')
    },
    currentTimestamp() {
        return new Date().toString();
    },
    instanceColor(){
      const instance = this.contact ? instanceObject(this.contact.instance_id) : null
      if ( this.unifyConnections && this.$store.getters["instance/chosenInstanceIds"].length > 1 && instance){
        return {
          name: instance.nickname || instance.name,
          color: instance.color || '#2c2c2c'
        }
      }
      return null;
    },
    unifyConnections() {
      return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
    },
    sentAtFormatted() {
        if (!this.lastMessage.sent_at) {
            return ''
        }

        const {
            year,
            month,
            day,
            hour,
            minute
        } = formatDate(this.lastMessage.sent_at.replace(/\s/, 'T'));

        let hourFormated = hour.toString().padStart(2, '0') + `:${minute}`;
        let hourTimeZone = getTimeZone(hourFormated, 'schedules');

        return `${day}/${month}/${year} ${hourTimeZone}`;
    },
    lastMessageFormatted() {
      if (this.lastMessage.message !== undefined) {
        const message = stylizeMessage(this.lastMessage.message)
        
        return `${!this.lastMessage.type ? 'Você:' : ''} ` + message
      }
      return '';
    },
    selectedTab() {
      return this.$store.state.chatContact.chatTab;
    }
  },
  methods: {
    async openPickingPopup(contact) {
      this.$store.dispatch('chatContact/setChatPickingPopup', contact);
      await this.sleep(100);
      this.$store.dispatch('chatContact/changeStatusPickingPopupActive', true);
    },
    updateTransferring(isTransferring) {
        this.transferring = isTransferring;
    },
    selectContact(contact) {
      setTimeout(
        () => {
          this.$emit('contactSelected', contact.id, this.selected);
        },
        100
      );
    },
    updateFinishedTickets(finishedTickets) {
        this.$emit('updateFinishedTickets', finishedTickets);
    },
    async openContactDropdown(contact) {
        this.$store.dispatch('chatContact/setChatContactDropdown', contact);
        await this.sleep(100);
        this.$store.dispatch('chatContact/changeStatusAttendancePopupActive', true);
    },
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    stopParentClick() {
        return;
    },
    hasAttendance(contact) {
        return !(contact.user_id && !contact.user.deleted_at);
    }
  }
}
</script>

<style lang="scss">
.instance-color {
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 50%;
  position: absolute;
}

.border-chip {
    border: 1px solid #888;
}

.vs-chip-research {
    background: #0c2860;
    color:white !important;
}
.vs-chip-maria {
    background: #36719a;
    color: white !important;
}

.inbox-contact-picker {
  position: relative;
  margin: 0 10px;
  width: 40%;
  height: 65px;

  &__picking-button[style] {
    background: #fff !important;
    position: absolute;
    left: 0;
    bottom: 0;
    padding-top: .500rem !important;
    padding-bottom: .500rem !important;
    width: 100%;
  }
}
</style>
